import React from 'react'
import Options from './options'
import Cropper from './cropper'
import Filters from './filters'
import ImageStore from '../../../stores/image-store'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import SelectorActions from '../../../actions/selector-actions'
import createReactClass from 'create-react-class'


var _imageLoading = false;

var Detailed = createReactClass({
    mounted: false,
	/**
	 * Method for applying a filter to the edited item. This is called from the Filter component via the callback props.
	 * @param {string} - filterValue of the filter that should be applied
	 */
	filterCallback: function(filterValue) {
		SelectorActions.setItemImageFilterValue(this.props.item.id, 'effect.type', filterValue);
	},

	componentDidMount: function() {
        this.mounted = true;
		window.addEventListener('resize', this._handleResize);
	},

	componentWillUnmount: function() {
        this.mounted = false;
		window.removeEventListener('resize', this._handleResize);
	},

	componentDidUpdate: function() {
		var cropperSettings = this.getCropperSettings();
		//Save the crop height and width, this will be used when creating JSON output
		this.props.item.saveCropWidthAndHeight((cropperSettings.selectionSettings.width / cropperSettings.imageSize.width)*100, (cropperSettings.selectionSettings.height / cropperSettings.imageSize.height)*100);
	},
	_resizeImageToFitContainer: function(imageWidth, imageHeight, containerWidth, containerHeight, angle) {
		// Resize the image elements to fit the selectionSize
		var item = this.props.item,
			widthRatio, heightRatio, imageRatio,
			newWidth, newHeight,containerRatio;

		if(!angle) angle = 0;

		widthRatio = containerWidth / imageWidth;
		heightRatio = containerHeight / imageHeight;
		imageRatio = imageWidth / imageHeight;
		containerRatio = containerWidth / containerHeight;
		// If image is wider than the container
		if(heightRatio > widthRatio) {
			newHeight = imageHeight * heightRatio;
			newWidth = containerHeight * imageRatio;
		}
		// Else if the image ratio is narrower than the container
		else {
			newWidth = imageWidth * widthRatio;
			newHeight = containerWidth / imageRatio;
		}

		return { width: newWidth, height: newHeight };
	},

	/**
	 * Handle resize of browser window
	 */
	_handleResize: function() {
		var item = this.props.item;
		var cropperSettings = this.getCropperSettings();

		// Update the XYPixels
		SelectorActions.setCropScale(item, item.options.scale);
		item.saveCropWidthAndHeight(
			(cropperSettings.selectionSettings.width/cropperSettings.imageSize.width)*100,
			(cropperSettings.selectionSettings.height/cropperSettings.imageSize.height)*100
		);
	},

	imageLoadingCallback: function() {
		//console.log("imageLoadingCallback");
		if(_imageLoading) {
			_imageLoading = false;
			if (this.mounted) {
				this.forceUpdate();
			}
		}
		else {
			_imageLoading = true;
		}
	},

	handleRotate: function(angle) {

	},

	saveEdit: function() {
		this.props.saveCallback();
	},

	_getOverlaySettings: function() {
		var settings = {};

		return settings;
	},
	/**
	 * Method for calculating the selection/crop size area.
	 *
	 */
	_getSelectionSettings: function (params) {
		var settings = {},
			item = this.props.item,
			prodOptions = this.props.productOptions,
			customSettings = item.getCustomSettings(),
			productWidth = item.options.productWidth,
			productHeight = item.options.productHeight,
			fillerWidth = 0, fillerHeight = 0,
			maxWidth = document.getElementById('ope-product-list__items').offsetWidth - 30, // Leave at least 15px margin on each size
			maxHeight = window.innerHeight - 100;

		var aspectRatio = item.isPortrait && !customSettings ? productHeight / productWidth : productWidth / productHeight;
		try {
			var angle = item.options.imageFilter.rotate.angle;
		} catch (e) {}

		if(maxHeight > 510) {
			maxHeight = 510;
		}

		var width = maxWidth;
		var height = width / aspectRatio;

		if(height > maxHeight) {
			height = maxHeight;
			width = height * aspectRatio;
		}

		// If custom canvas sizes are defined, adjust size of the selection
		if(customSettings) {
			var widthAspect = customSettings.canvasWidth / item.options.productWidth;
			var heightAspect = customSettings.canvasHeight / item.options.productHeight;
			// Scale down the size of the canvas to fit within the product
			width = width * widthAspect;
			height = height * heightAspect;
			fillerHeight = height / heightAspect;
			fillerWidth = width / widthAspect;

			// Recalculate if width exceeds maxHeight
			if(fillerWidth > maxHeight) {
				// Scale down the size
				var aspect = fillerWidth / maxHeight;

				fillerWidth = height / heightAspect;
				fillerHeight = width / widthAspect;

				fillerWidth = fillerWidth / aspect;
				fillerHeight = fillerHeight / aspect;
				width = width / aspect;
				height = height / aspect;
			}
			else {
				fillerHeight = height / heightAspect;
				fillerWidth = width / widthAspect;
			}
		}

		return {
			width: Math.floor(width),
			height: Math.floor(height),
			fillerWidth: fillerWidth,
			fillerHeight: fillerHeight,
			x: ((maxWidth - width) / 2 ) + 15,
			y: 15,
			angle: angle
		};
	},

	/**
	 * Method for calculating the size of the image (not the crop/selection but the full image).
	 * Returns object.
	 * Requires an {Object} as parameter with the following properties declared:
	 * @param {Number} - cropWidth
	 * @param {Number} - cropHeight
	 * @param {Number} - angle
	 */
	_getImageSettings: function (params) {
		var settings = {},
			item = this.props.item,
			// Get image size from order item
			imageSize = item.getSizeWithRotation(),
			imageWidth = imageSize.width, imageHeight = imageSize.height;

		settings = this._resizeImageToFitContainer(imageWidth, imageHeight, params.cropWidth, params.cropHeight, params.angle);
		return settings;
	},

	_getFillerSettings: function(item, size) {
		var item = this.props.item,
			prodOptions = this.productOptions,
			customSettings = item.getCustomSettings();

		if(customSettings === null) {
			// Return with 0 values
			return {
				'wrapper' : {
					left: 0, top: 0,
					width: 0,
					height: 0
				},
				'left' : {
					height: 0,
					width: 0
				},
				'right' : {
					height: 0,
					width: 0
				},
				'top' : {
					height: 0
				},
				'bottom' : {
					height: 0
				}
			}
		}
	},

	/**
	 * Cropper settings define the size of the cropper, the size of the image, the size
	 * of the product and the scale, rotation and such.
	 * @return {Object}
	 */
	getCropperSettings: function () {
		var item = this.props.item,
			prodOptions = this.props.productOptions,
			maxWidth, maxHeight,
			height, width,
			heightRatio, widthRatio,
			newWidth, newHeight,
			fillerWidth, fillerHeight,
			imageRatio, imageSize,
			aspectRatio, imageWidth, imageHeight,
			angle = 0,
			productHeight = item.options.productHeight,
			productWidth = item.options.productWidth,
			instance = this;

		var selectionSettings = instance._getSelectionSettings();

		var imageSettings = instance._getImageSettings({
			'cropWidth' : selectionSettings.width,
			'cropHeight' : selectionSettings.height,
			'angle' : angle
		});

		var cropperSettings = {
			selectionSettings: selectionSettings,
			overlaySize:{
				horisontal: {width: '100%', height: 15 },
				vertical: {width: selectionSettings.x, height: selectionSettings.fillerHeight > 0 ? selectionSettings.fillerHeight :  selectionSettings.height + 30 }
			},
			fillerSize: {
				height: selectionSettings.fillerHeight,
				width: selectionSettings.fillerWidth
			},
			imageSize: imageSettings // instance._resizeImageToFitContainer(imageWidth, imageHeight, width, height, angle)
		};

		cropperSettings.boundaries = {
			'x1' : Math.floor(selectionSettings.width), 'y1' : Math.floor(selectionSettings.height),
			'x2' : cropperSettings.imageSize.width, 'y2' : cropperSettings.imageSize.height
		};

		return cropperSettings;
	},

	render: function() {
		return (
			<div className="ope-editor__detailed" style={this.props.style} id={"ope-editor-detailed_" + this.props.item.getId()}>
				<Cropper item={this.props.item} settings={this.getCropperSettings()} rotateCallback={this.handleRotate}
					imageLoadingCallback={this.imageLoadingCallback} productOptions={this.props.productOptions}/>
				<Options item={this.props.item} saveCallback={this.props.saveCallback} resetCallback={this.props.resetCallback} />
				<Filters item={this.props.item } callback={this.filterCallback} />
			</div>
		);
	}
});

export default Detailed;
